<template>
  <div class="video-page">
    <el-card class="mt20">
      <div class="common-page common-head">
        <div class="common-page common-head-title">
          <i class="icon-tr--detailed" style="padding-right: 5px"></i>
          项目报告管理
        </div>
      </div>
      <div class="f-right">
        <div>
          <el-button v-hasPermi="['wenwu:program:add']" icon="el-icon-plus" type="primary" @click="edit(null)">新增</el-button>
        </div>
      </div>

      <el-table :data="list" style="margin-top: 40px;">
        <el-table-column prop="num" label="序号" align="center"> </el-table-column>

        <el-table-column prop="name" align="center" label="项目名称"> </el-table-column>
        <el-table-column prop="service_type" align="center" label="服务类型">
          <template scope="scope">
            {{ $map.serviceType[scope.row.service_type] }}
          </template>
        </el-table-column>
        <el-table-column prop="nick_name" align="center" label="所属集团"> </el-table-column>
        <el-table-column prop="starttime" align="center" label="创建时间"> </el-table-column>

        <el-table-column prop="newtime" align="center" label="最新报告上传时间"> </el-table-column>

        <!-- <el-table-column align="center" label="文件上传">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="add(scope.row, 1)"
            >文件上传</el-button
          >
        </template>
      </el-table-column> -->
        <el-table-column label="操作" align="center" width="160px">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" v-hasPermi="['wenwu:program:edit']" @click="edit(scope.row)">编辑</el-button>

            <router-link
              :to="{
                path: '/report/detail-proList',
                query: { id: scope.row.uuid },
              }"
              v-hasPermi="['wenwu:program:detail']"
            >
              <el-button type="primary" size="mini">详情</el-button>
            </router-link>

            <el-popconfirm title="确定执行此操作吗？" class="cursor" @onConfirm="changeStatus(scope.row)" @confirm="changeStatus(scope.row)" v-hasPermi="['wenwu:program:remove']">
              <a slot="reference">
                <el-button type="danger" size="mini">删除</el-button>
              </a>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        class="mt20 tx-center"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :page-size="10"
        layout="prev, pager, next, jumper"
        :total="count"
      >
      </el-pagination>
    </el-card>

    <el-dialog :title="isEdit == 1 ? '编辑项目' : '新增项目'" :visible.sync="showdia">
      <el-form ref="form" :model="editData" label-width="100px" size="small" class="flex1">
        <el-form-item label="项目名称" prop="name" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
          <el-input v-model="editData.name" clearable></el-input>
        </el-form-item>
        <el-form-item prop="serviceType" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" label="服务类型" inline-message>
          <!-- <el-checkbox-group  v-model="services" @change="handlechange">
              <el-checkbox label="1" key="评估">评估 </el-checkbox>
              <el-checkbox label="2" key="维保"> 维保</el-checkbox>
              <el-checkbox label="3" key="监控">监控</el-checkbox>
              <el-checkbox label="4" key="电检">电检</el-checkbox>

              <el-checkbox label="5" key="消检">消检</el-checkbox>
             </el-checkbox-group> -->
          <el-select v-model="editData.serviceType">
            <el-option value="1" key="评估" label="评估">评估</el-option>
            <el-option value="2" key="维保" label="维保">维保</el-option>

            <el-option value="3" key="监控" label="监控">监控</el-option>

            <el-option value="4" key="电检" label="电检">电检</el-option>

            <el-option value="5" key="消检" label="消检">消检</el-option>
            <el-option value="6" key="验收" label="验收">验收</el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="isEdit" label="所属集团" prop="userId" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
          <el-select v-model="editData.userId" filterable remote placeholder="请输入关键词">
            <el-option v-for="item in compList" :key="item.userId" :label="item.nickName" :value="item.userId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="center">
        <el-button :loading="btnload" type="primary" @click="addCommit" size="small">提交</el-button>
        <el-button @click="showdia = false" size="small">取消</el-button>
      </div>
    </el-dialog>
    <!--  
 <el-dialog title="搜索" :visible.sync="showdia2">
      <el-form label-width="100px" size="small" class="flex1">
            <el-form-item label="单位名称">
          <el-input v-model="searchForm.tr_name" clearable></el-input>
        </el-form-item>
          
        
      </el-form>
      <div class="center">
        <el-button
          type="primary"
          @click="editVideo(null)"
          size="small"
          :loading="isUpload"
          >提交</el-button
        >
        <el-button @click="showEdit = false" size="small">取消</el-button>
      </div>
    </el-dialog> -->
    <!-- <unit v-show="false" ref="unit" isson="1"></unit> -->
  </div>
</template>

<script>
// import {
//   getList,
//   getDetail,
//   add,
//   edit,
//   getVideo,
//   editVideo,
// } from "../../api/media.js";
// import {
//   getUser,
//   getLaw,
//   getRandom,
//   getSociety,
//   getUnit,
// } from "../../api/common";
// import OSS from "ali-oss";
// import unit from "../system/society";
export default {
  data() {
    return {
      editData: {
        name: '',
        serviceType: '',
        userId: '',
      },
      btnload: false,
      count: 0,
      showdia: false,
      params: {
        page: 1,
        name: '',
      },
      list: [],
      isEdit: 0,
      canEditLength: false,
    };
  },
  created() {
    this.getList();
    this.$get('/system/user/itemUserList').then((res) => {
      this.compList = res.data;
    });
  },
  methods: {
    edit(val) {
      if (val) {
        this.editData.uuid = val.uuid;
        this.editData.userId = val.user_id;
        this.editData.name = val.name;
        this.editData.serviceType = val.service_type;
        this.showdia = true;
        this.isEdit = 1;
      } else {
        this.isEdit = 0;
        this.showdia = true;
      }
    },
    resetSearch() {
      this.params.page = 1;
      this.searchForm = {
        tr_project_name: '',
        tr_unit: '',
        tr_type: '',
      };
      this.params = { ...this.params, ...this.searchForm };
      this.getList();
    },

    //修改 删除
    changeStatus(it, st) {
      this.$post('/dzda/delxiangmu', { uuid: it.uuid }).then((res) => {
        if (res.code == 200) {
          // this.$message.success(res.msg || '操作成功');
          this.$message({
                message: res.msg || '操作成功',
                type: 'success',
                duration: 700,
              });
          this.getList();
        }
      });
    },

    getList() {
      this.loading = true;
      this.$post('/dzda/listxiangmu', this.params).then((res) => {
        console.log(res);
        this.list = res.data.list;
        this.count = res.data.count;
      });
    },

    // 添加

    addCommit(status) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.btnload = true;

          var url = this.isEdit ? '/dzda/updatexiangmu' : '/dzda/addxiangmu';
          this.$post(url, this.editData).then((res) => {
            if (res.code == 200) {
              // this.$message.success(res.msg || '操作成功');
              this.$message({
                message: res.msg || '操作成功',
                type: 'success',
                duration: 700,
              });
              this.showdia = false;
              this.btnload = false;
            }
          });
        }
      });
    },

    handleCurrentChange1(page) {
      this.video_params.page = page;
      this.getVideoData();
    },

    handleCurrentChange(page) {
      this.params.page = page;
      this.getList();
    },
    searchSubmit() {
      this.editData = {
        name: '',
        serviceType: '',
        userId: '',
      };
      this.getList();
    },
  },
  watch: {
    showdia(val) {
      if (!val) {
        this.searchSubmit();
        this.isEdit = 0;
        this.btnload = false;
      }
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.file-list {
  li {
    position: relative;
    padding: 20px 10px;
    border-bottom: 1px solid #eee;

    img {
      width: 75px;
      margin-right: 15px;
    }

    .el-icon-close {
      position: absolute;
      right: 20px;
      top: 8px;
      cursor: pointer;
    }
  }
}

.mb5 {
  margin-bottom: 5px;
}

.ml20 {
  margin-left: 20px;
}
.mt10 {
  margin-top: 10px !important;
}
// 取消卡片样式
.el-card {
  box-shadow: 0 0 0 0;
  border: none;
}
</style>
